var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 400 400",
    style: {
      enableBackground: "new 0 0 400 400"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#C2CCD2;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "289.4,53 270.4,86.8 267.1,113.8 233.1,174.2 188.6,174.2 221.8,115.6 221.8,53 187.4,53 169.2,86.5  166,113.8 117.6,200 125.8,220.3 155.9,220.3 142.2,255.1 116.4,227.4 119.5,268.1 75,269.9 110.4,294.9 85.2,332.5 125.9,319.2  142.6,359.5 155.4,315.6 200.9,327.3 171.5,293.3 207.6,263.5 170.3,265.9 210.7,220.3 263.7,220.3 322.4,116.3 322.4,53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "289.4,53 270.4,86.8 267.1,113.8 233.1,174.2 188.6,174.2 221.8,115.6 221.8,53 187.4,53 169.2,86.5 166,113.8  117.6,200 125.8,220.3 155.9,220.3 142.2,255.1 116.4,227.4 119.5,268.1 75,269.9 110.4,294.9 85.2,332.5 125.9,319.2 142.6,359.5  155.4,315.6 200.9,327.3 171.5,293.3 207.6,263.5 170.3,265.9 210.7,220.3 263.7,220.3 322.4,116.3 322.4,53  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "282.3,83.1 298.4,83.1 309.6,62.1 294.1,62.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "181.2,83.2 198.5,83.1 209.6,62.1 192.8,62.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "177.1,109.6 192.7,109.6 194.1,91.6 179.1,91.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "277.8,109.6 293.5,109.6 294.9,91.6 279.8,91.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M274.5,120.4l-35.2,62h-84.5l35.2-62h-16.6l-42.5,75h47.2l-35.7,79.9l-14.8-16.5l0.8,19.4l-23.9,1.4l19.2,13.5 L110,313.4l22.1-7.2l9.1,21.9l6.9-23.8l24.6,6.3l-15.8-18.4l19.5-16.1l-30.2,1.4l55.5-82H249l41.8-75L274.5,120.4L274.5,120.4z  M136.3,297.8c-4,0-7.2-3.2-7.2-7.1c0-4,3.2-7.1,7.2-7.1s7.1,3.2,7.1,7.1C143.4,294.6,140.2,297.8,136.3,297.8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSas);
export default __webpack_public_path__ + "static/media/SAS.b496c6d27762bf40dd0bc7e2bcfa2e45.svg";
export { ForwardRef as ReactComponent };